import { render, staticRenderFns } from "./purchase_edit.vue?vue&type=template&id=4e0c5e24&scoped=true&"
import script from "./purchase_edit.vue?vue&type=script&lang=js&"
export * from "./purchase_edit.vue?vue&type=script&lang=js&"
import style0 from "./purchase_edit.vue?vue&type=style&index=0&id=4e0c5e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c5e24",
  null
  
)

export default component.exports